export const PREMIUM_EASE = [0.22, 1, 0.36, 1] as const;

export const MOTION_DURATION = {
  fast: 0.24,
  standard: 0.55,
  slow: 0.7,
} as const;

